import { DRIVE_DOCS_ACTION_SET, IDriveDocsActionSetAction } from './types';
import { TDriveDocsAction } from '../driveDocs/actions/types';

export const driveDocsActionSetAction = (
    driveDocsAction: TDriveDocsAction
): IDriveDocsActionSetAction => ({
    type: DRIVE_DOCS_ACTION_SET,
    driveDocsAction
});
